module.exports = __webpack_public_path__ + "static/fonts/CeraPro-Regular.77f532e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CeraPro-Regular.woff
// module id = Lk8Z
// module chunks = 1